import { PressReleases } from '../db.js'
import { IssueLight } from './IssueEntity.js'
import { WarrantLight } from './WarrantEntity.js'
import { ConvertibleLight } from './ConvertibleEntity.js'
import { Selectable } from 'kysely'
import { IssueType } from './IssueType.js'
import { TransactionType } from './TransactionType.js'

export enum NewsType {
    NewsFlash,
    NewsArticle,
    PressRelease,
    CompanyFinancialCalendar,
    Report,
    MarketCommentary,
    EconomicCalendarToday,
    EconomicCalendarThisWeek,
    SystemsMessages,
}

export const PRESS_RELEASES_FILTER_CONTENT_TYPE = {
    ALL: 'all',
    ANALYZE_AND_IR: 'analyzeAndIr',
    REPORTS: 'reports',
    RELATED_TRANSACTIONS: 'relatedTransactions',
    PRESS_RELEASES: 'pressReleases',
} as const

export type PressReleasesFilterContentType =
    (typeof PRESS_RELEASES_FILTER_CONTENT_TYPE)[keyof typeof PRESS_RELEASES_FILTER_CONTENT_TYPE]

export type PressReleaseListFilter = {
    companyId?: string
    maxPublicationDate?: string
    publicationDate?: string
    preferredLanguage?: 'sv' | 'en'
    search?: string
    contentType?: PressReleasesFilterContentType
}

type PressReleaseTranslation = {
    accuracyScore: number
    language: string
    prId: string
}

export type PressReleaseListItem = Pick<
    Selectable<PressReleases>,
    'companyId' | 'distributorName' | 'language' | 'publishedAt' | 'title' | 'id'
> & {
    companyName: string | null
    newsType: NewsType | null
    relatedTransactions: Array<
        | { issueType: null; entityType: Exclude<TransactionType, 'Issue'>; id: string | null }
        | { issueType: IssueType; entityType: 'Issue'; id: string | null }
    >
    translations: Array<PressReleaseTranslation>
}

type BaseRelatedTransaction = {
    id: string
    name: string | null
}

export type RelatedTransaction = BaseRelatedTransaction & (ConvertibleLight | IssueLight | WarrantLight)

export type PressReleaseSingleItem = PressReleaseListItem &
    Pick<PressReleases, 'body'> & {
        attachments: Array<{ caption: string | null; mime: string | null; url: string }>
        rankNumber: number | null
        relatedTransactions: Array<RelatedTransaction>
    }
